import React from "react";
import { Loader2 } from "lucide-react";

export default function LoginV3Loading({ title, subtitle }) {
    return (
        <div className="relative min-h-screen bg-white flex items-center justify-center px-6 overflow-hidden">
            <div
                className="pointer-events-none absolute -top-32 -right-44 w-[720px] h-[720px] rounded-full opacity-70 blur-[80px]"
                style={{ background: "radial-gradient(circle, #d9c8ee 0%, rgba(217,200,238,0) 70%)" }}
                aria-hidden="true"
            />
            <div className="relative z-10 w-full max-w-[420px] rounded-[20px] bg-white border border-[#e9e7ee] shadow-[0_1px_2px_rgb(23_26_31/0.04),0_24px_56px_-24px_rgb(124_107_176/0.18)] p-10 text-center">
                <Loader2 className="w-8 h-8 mx-auto mb-4 text-[#7c6bb0] animate-spin" strokeWidth={2} />
                <h2 className="text-xl font-semibold text-[#171a1f] mb-2">{title}</h2>
                <p className="text-[#6b7280]">{subtitle}</p>
            </div>
        </div>
    );
}
